import React from 'react';
import { Link } from 'react-router-dom';
import { Layers, ArrowRight } from 'lucide-react';

/**
 * BundleCallout — promotes the 3-Day SharePoint Copilot Series Bundle on
 * individual SHARECOP course pages.
 *
 * Props:
 *   bundle: { code, name, aud, savings }  (course.series.bundle)
 */
const BundleCallout = ({ bundle }) => {
  if (!bundle) return null;

  // Best-effort: extract a numeric savings figure from the savings string,
  // e.g. "Save AUD 390 (~16%) vs individual" -> "390"
  const savingsMatch = typeof bundle.savings === 'string'
    ? bundle.savings.match(/(\d[\d,]*)/)
    : null;
  const savingsAmount = savingsMatch ? savingsMatch[1] : null;

  return (
    <section className="mb-12 rounded-2xl overflow-hidden shadow-lg bg-gradient-to-br from-[#422680] via-[#5a3499] to-[#660F56] text-white">
      <div className="p-6 sm:p-8">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 bg-white/15 rounded-xl p-3">
            <Layers size={28} className="text-white" />
          </div>
          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-2 mb-2">
              <span className="inline-block bg-white/20 text-white text-xs font-mono font-bold px-2.5 py-1 rounded-full tracking-wide">
                {bundle.code}
              </span>
              <span className="inline-block bg-amber-400 text-[#422680] text-xs font-bold px-2.5 py-1 rounded-full">
                Bundle offer
              </span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold leading-tight mb-2">
              {savingsAmount
                ? `Save AUD ${savingsAmount} with the 3-Day SharePoint Copilot Bundle`
                : `Save with the ${bundle.name}`}
            </h3>
            <p className="text-sm sm:text-base text-white/90 mb-5 leading-relaxed">
              Get all three SharePoint Copilot courses (FND-001, GOV-001, ARCH-001) for AUD {bundle.aud?.toLocaleString?.() || bundle.aud} — ~16% off individual pricing.
            </p>
            <Link
              to="/pathways/sharepoint-copilot-series-bundle"
              className="inline-flex items-center gap-2 bg-white text-[#422680] hover:bg-gray-100 font-bold text-sm px-5 py-2.5 rounded-lg transition-colors"
            >
              View bundle
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BundleCallout;
